class CollectionDescription extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[data-collection-description-trigger]').addEventListener('click', () => {
      this.classList.toggle('collection-hero__description--is-open');
    });
  }
}

if (!customElements.get('collection-description')) {
  customElements.define('collection-description', CollectionDescription);
}
